import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const HallofFameMainWrapper = styled(Box)({
  width: "100%",
  background: "#ffffff"
});

export const BannerSection = styled(Box)({
  width: "100%",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  minHeight: "260px",
});

export const BannerContent = styled(Box)({
  padding: "105px 5%",
  width: "70%",
});

export const BannerTitle = styled(Typography)({
  color: "#FFFFFF",
  fontSize: "32px",
  fontWeight: 600,
  fontFamily: "Graphik",
  lineHeight: "100%",
  letterSpacing: 0,
});

export const ContentWrapper = styled(Box)({
  width: "90%",
  margin: "auto",
});

export const DescriptionText = styled(Typography)({
  fontFamily: "Graphik",
  fontWeight: 400,
  fontSize: "14px",
  color: "#000000",
  marginBottom: "40px",
  marginTop: "40px",
});

export const SectionHeaderRow = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "24px",
});

export const SectionTitle = styled(Typography)({
  fontFamily: "Graphik",
  fontSize: "24px",
  fontWeight: 600,
  color: "#000000",
});

export const UpdatedText = styled(Typography)({
  fontSize: "14px",
  color: "#818180",
  fontFamily: "Graphik",
});

export const CardsRow = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "30px",
  width: "100%",

  [theme.breakpoints.down("lg")]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },

  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "1fr",
  },
}));

export const ContributorCard = styled(Box)({
  position: "relative",
  background: "#FFFFFF",
  border: "1.5px solid #CFCFCF",
  padding: "10px 4px 4px",
  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.15)",
  textAlign: "center",
  width: "100%",
});

export const BadgeWrapper = styled(Box)({
  position: "absolute",
  right: "12px",
});

export const AvatarWrapper = styled(Box)({
  position: "relative",
  width: "96px",
  height: "96px",
  // margin: "0 auto 4px",
});

export const AvatarImage = styled("img")({
  width: "75px",
  height: "75px",
  borderRadius: "50%",
  objectFit: "cover",
  padding:"10px",
  marginLeft:"10px"
});

export const StarIcon = styled("img")({
  position: "absolute",
  bottom: "4px",
  right: "4px",
  width: "32px",
  height: "32px",
});
export const ContributorBox = styled(Box)({
  display:"flex"

})

export const ContributorRoleSection = styled(Box)({
alignContent: "center",
marginLeft: "5px",
marginBottom: "10px"
})
export const ContributorName = styled(Typography)({
  fontFamily: "Graphik",
  fontSize: "14px",
  fontWeight: 600,
  color: "#000000",
  // marginBottom: "2px",
  textAlign:"left",
  lineHeight:"normal"
});

export const ContributorRole = styled(Typography)({
  fontFamily: "Graphik",
  fontWeight: 400,
  fontSize: "12px",
  color: "#818180",
  // marginBottom: "10px",
  textAlign:"left",
  lineHeight:"normal"
});
export const Divider = styled(Box) ({
  borderBottom: "1px solid #DBDBDB",
  marginLeft:"10px",
  marginRight:"10px",
  marginBottom:"10px"
})
export const StatsRow = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
});

export const StatItem = styled(Box)({
  flex: 1,
  textAlign: "center",
  padding: "0 3px",
  position: "relative",

  "&:not(:last-of-type)::after": {
    content: '""',
    position: "absolute",
    right: 0,
    top: "4px",
    bottom: "4px",
    width: "1px",
    background: "#CFCFCF",
  },
});

export const StatNumber = styled(Typography)({
  fontSize: "20px",
  fontWeight: 600,
  color: "#7500C0",
  fontFamily: "Graphik",
});

export const StatLabel = styled(Typography)({
  fontSize: "13px",
  color: "#000000",
  fontFamily: "Graphik",
});

export const AskSectionWrapper = styled(Box)({
  width: "90%",
  margin: "auto",
  marginTop: "40px",
});

export const AskHeaderRow = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "8px",
});

export const AskTitle = styled(Typography)({
  fontSize: "24px",
  fontWeight: 600,
  fontFamily: "Graphik",
});

export const AskSubtitle = styled(Typography)({
  fontSize: "14px",
  color: "#000000",
  marginBottom: "28px",
});

export const NavButtons = styled(Box)({
  display: "flex",
  gap: "8px",
});

export const ArrowButton = styled(Box)(({ disabled }) => ({
  width: "36px",
  height: "36px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: disabled ? "#D9D9D9" : "#A100FF",
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? 0.6 : 1,
  transition: "all 0.2s ease",
  pointerEvents: disabled ? "none" : "auto",
}));

export const CarouselViewport = styled(Box)({
  overflow: "hidden",
  width: "100%",
  padding: "2px",
});

export const CarouselTrack = styled(Box)(({ offset = 0 }) => ({
  display: "flex",
  gap: "24px",
  transition: "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
  transform: `translateX(-${offset}%)`,
}));

export const AskCard = styled(Box)({
  flex: "0 0 calc((100% - 72px) / 4)",
  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.15)",
  backgroundColor: "#FFFFFF",
  border: "1px solid #7B589A",
  transition: "transform 0.25s ease, box-shadow 0.25s ease",
  cursor: "pointer",

  "&:hover": {
    transform: "translateY(-6px)",
    boxShadow: "0px 12px 22px rgba(0,0,0,0.2)"
  }
});

export const HeaderIcon = styled("img")({
  width: "25px",
  height: "25px",
  objectFit: "contain",
});

export const AskCardHeader = styled(Box)({
  background: "#E6DCFF",
  height: "48px",
  padding: "0 16px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  fontSize: "14px",
  fontWeight: 500,
  fontFamily: "Graphik",
});

export const AskCardBody = styled(Box)({
  padding: "18px 16px 20px",
});

export const ProfileRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  marginBottom: "10px",
});

export const SmallAvatar = styled("img")({
  width: "36px",
  height: "36px",
  borderRadius: "50%",
  objectFit: "cover",
});

export const ProfileName = styled(Typography)({
  fontSize: "14px",
  fontWeight: 600,
  fontFamily: "Graphik",
});

export const ProfileRole = styled(Typography)({
  fontSize: "10px",
  color: "#000000",
  fontFamily: "Graphik",
});

export const MetricRow = styled(Box)({
  display: "flex",
  alignItems: "baseline",
  gap: "6px",
  marginBottom: "8px",
});

export const MetricNumber = styled(Typography)({
  fontSize: "20px",
  fontWeight: 700,
  color: "#7500C0",
  fontFamily: "Graphik",
});

export const SkillTags = styled(Box)({
  display: "flex",
  gap: "8px",
  flexWrap: "wrap",
});

export const Tag = styled(Box)({
  fontSize: "11px",
  padding: "4px 8px",
  background: "#F1F1EF",
});

export const Pagination = styled(Box)({
  display: "flex",
  justifyContent: "center",
  gap: "8px",
  marginTop: "18px",
  marginBottom: "-20px",
});

export const Dot = styled(Box)(({ active }) => ({
  width: "8px",
  height: "8px",
  background: active ? "#7500C0" : "#D9D9D9",
}));
export const LeaderboardWrapper = styled(Box)({
  display: "grid",
  width: "100%",
  gridTemplateColumns: "40% 60%",
  // alignItems: "end",
  marginTop: "35px"
});
export const LeaderboardImageWrapper = styled(Box)({
  width: "100%",
  height: "100%",
  display: "flex",
  // alignItems: "end",
});

export const LeaderboardImage = styled("img")({
  width: "100%",
  height: "100%",   
  display: "block",
});
// export const LeaderboardImage = styled(Box)({
//   backgroundImage: `url("/images/HallofFame/leaderboard-img1.png")`,
//   backgroundSize: "cover",
//   backgroundPosition: "center 15%",
//   backgroundRepeat: "no-repeat",
// });
export const LeaderboardContent = styled(Box)({
  // width: "62%",
  background: "#E6DCFF",
  padding: "20px 45px 0px 45px",
  boxSizing: "border-box",
  height: "100%" 
});

export const LeaderboardHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  marginBottom: "20px",
});

export const LeaderboardTitle = styled(Typography)({
  fontSize: "24px",
  fontWeight: 600,
  fontFamily:"Graphik"
});

export const LeaderboardSubtitle = styled(Typography)({
  fontSize: "14px",
  color: "#000000",
  marginTop: "4px",
  fontFamily:"Graphik"
});

export const LeaderboardList = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  "& > *:last-child": {
    marginBottom: 0,
  }
});

export const LeaderboardRow = styled(Box)({
  background: "#FFFFFF",
  display: "flex",
  alignItems: "center",
  padding: "8px 35px 8px 35px",
  boxSizing: "border-box",
});

export const RankText = styled(Typography)({
  width: "70px",
  fontSize: "18px",
  fontWeight: 600,
  color: "#7500C0",
  fontFamily:"Graphik"
});

export const UserSection = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  flex: 1,
});

export const UserAvatar = styled("img")({
  width: "28px",
  height: "28px",
  borderRadius: "50%",
  objectFit: "cover",
});

export const UserName = styled(Typography)({
  fontSize: "16px",
  fontWeight: 600,
  fontFamily:"Graphik"
});

export const MetricSection = styled(Box)({
  alignItems: "center",
});

export const MetricBlock = styled(Box)({
  display: "flex",
  alignItems: "baseline",
  gap: "6px",
  minWidth: "180px",
});

export const MetricValue = styled(Typography)({
  fontSize: "18px",
  fontWeight: 700,
  color: "#7500C0",
  fontFamily:"Graphik"
});
